import React from "react";
import NodePublicationTeaser from "components/Publication/NodePublicationTeaser";

export default function NodePublicationList({ nodes }) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-8">
      {nodes.map((node) => (
        <div key={node.id}>
          <NodePublicationTeaser node={node} />
        </div>
      ))}
    </div>
  );
}
